var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82537 10.192L9.87689 12.0375C10.0004 12.1129 10.1435 12.1501 10.2881 12.1445C10.4327 12.1388 10.5724 12.0904 10.6896 12.0055C10.8068 11.9206 10.8963 11.8029 10.9467 11.6673C10.9972 11.5316 11.0064 11.3841 10.9732 11.2432L10.1642 7.77199L12.8627 5.43333C13.3559 5.00678 13.0912 4.19782 12.444 4.14683L8.89142 3.84481L7.50196 0.564812C7.25191 -0.030393 6.39882 -0.030393 6.14877 0.564812L4.75833 3.83795L1.20671 4.13898C0.559536 4.19095 0.294783 4.99992 0.787028 5.42647L3.48653 7.76512L2.67756 11.2363C2.64452 11.3771 2.65379 11.5244 2.70423 11.6599C2.75466 11.7954 2.844 11.9129 2.96103 11.9978C3.07805 12.0826 3.21754 12.131 3.36198 12.1369C3.50642 12.1427 3.64936 12.1057 3.77286 12.0306L6.82537 10.192Z",
    fill: "#E33745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/StarRating.d50c3919d9d0fc8a5a4186d82f9d4796.svg";
export { ForwardRef as ReactComponent };